import InteresList from './InteresList'
export {InteresList}
export default InteresList
